import { makeStyles } from "@fluentui/react-components";
import { Outlet } from "react-router-dom";
import WorkerPort from "../../services/worker";
import { HandleWorkerMessage } from "../../services/worker/MessageHandlers";

const useStyles = makeStyles({
  root: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },
});

const App = () => {
  WorkerPort.onmessage = HandleWorkerMessage();

  const styles = useStyles();

  return (
    <div id="rootContainer" key={"root-container-app"} className={styles.root}>
      <Outlet />
    </div>
  );
};

export default App;
